<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-row">
      <!-- Draw Card -->
      <div v-if="action" class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-2">
        <div class="vx-card p-5" :style="isSmallerScreen ? '' : `height: 75vh`">
          <template v-if="fromHistory">
            <div class="vx-row">
              <div class="vx-col w-full">
                <h3 style="font-size: 16px; text-align: center">
                  Search History
                </h3>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <label class="vs-input--label">Device</label>
                <v-select
                  :options="deviceList"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="track.device"
                  @search="searchDevice"
                  class="mb-4 md:mb-0"
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <label class="vs-input--label">Start Time</label>
                <flat-pickr
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                  style="width: 100%"
                  v-model="track.start"
                  placeholder="Start Time"
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <label class="vs-input--label">End Time</label>
                <flat-pickr
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                  style="width: 100%"
                  v-model="track.end"
                  placeholder="End Time"
                />
              </div>
            </div>

            <div class="flex mb-5">
              <vs-button
                id="searchBtn"
                class="vs-con-loading__container mr-2 mt-2 btn-custom"
                @click="searchTrack"
                size="small"
                color="success"
              >
                <span class="align-middle">Search</span>
              </vs-button>
            </div>

            <div v-if="isSearchHistory && !isCropHistory" class="vx-row mb-10">
              <div class="vx-col md:w-5/6">
                <label class="vs-input--label">Crop</label>
                <vs-slider
                  :disabled="isCropHistory"
                  v-model="slider.value"
                  :max="slider.max"
                  style="width: 90%; margin: 10px 10px"
                />
              </div>
              <div class="vx-col md:w-1/6 w-full">
                <vs-button
                  @click="crop"
                  size="small"
                  color="warning"
                  icon-pack="feather"
                  icon="icon-crop"
                  class="mr-2 mt-2 btn-custom"
                  style="margin-top: 17px !important"
                ></vs-button>
              </div>
            </div>
          </template>

          <div class="vx-row">
            <div class="vx-col w-full">
              <h3 style="font-size: 16px; text-align: center">Route Data</h3>
            </div>
          </div>

          <div class="vx-row">
            <div v-if="actor.privilege < 4" class="vx-col w-full">
              <label class="vs-input--label">User</label>
              <v-select
                @search="searchGeneral"
                :options="userList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.user_id"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-2/2 w-full">
              <vs-input
                label="Route Name"
                class="w-full"
                v-model="input.name"
              />
            </div>
          </div>

          <div class="flex">
            <vs-button
              @click="cancel"
              size="small"
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              class="mr-2 mt-2 btn-custom"
            >
              <span class="align-middle">Cancel</span>
            </vs-button>
            <vs-button
              id="submitBtn"
              class="vs-con-loading__container mr-2 mt-2 btn-custom"
              @click="submit"
              size="small"
              color="success"
              icon-pack="feather"
              icon="icon-check"
            >
              <span class="align-middle">Submit</span>
            </vs-button>
          </div>
        </div>
      </div>

      <!-- Default Card -->
      <div v-else class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-2">
        <div class="vx-card p-5" :style="isSmallerScreen ? '' : `height: 75vh`">
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="keyword"
            @keyup="search"
            placeholder="Search..."
          />
          <div class="table-container">
            <vs-button
              @click="add(false)"
              size="small"
              class="mr-2 mt-2 btn-custom"
              >Draw Route</vs-button
            >
            <vs-button
              color="warning"
              size="small"
              @click="add(true)"
              class="mr-2 mt-2 btn-custom"
              >Add From History</vs-button
            >

            <h3 class="sidebar-title">Route List</h3>
            <table class="sidebar-table">
              <thead>
                <tr>
                  <th style="min-width: 15px">&nbsp;</th>
                  <th>Name</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody v-if="data.length > 0">
                <tr v-for="(item, index) in data" :key="index">
                  <td>
                    <vs-checkbox
                      icon-pack="feather"
                      icon="icon-map-pin"
                      color="rgb(38, 187, 174)"
                      v-model="selected"
                      :vs-value="item.id"
                      @click="check(item, $event)"
                    ></vs-checkbox>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>
                    <vs-dropdown vs-trigger-click>
                      <vs-button
                        radius
                        color="dark"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-settings"
                      ></vs-button>
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="edit(item)"
                          >Edit</vs-dropdown-item
                        >
                        <vs-dropdown-item @click="del(item.id)"
                          >Delete</vs-dropdown-item
                        >
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    v-if="loading"
                    colspan="4"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    <vs-icon icon-pack="feather" icon="icon-loader"></vs-icon>
                    Loading....
                  </td>
                  <td
                    v-else
                    colspan="4"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    No Data Available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <vs-pagination
            style="margin-top: 20px"
            color="rgb(38, 187, 174)"
            :total="n_page"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
      <div class="vx-col w-full lg:w-2/3 xl:w-3/4 sm:w-full">
        <div
          class="vx-card p-3"
          :style="isSmallerScreen ? `height: 82vh` : `height: 75vh`"
        >
          <editable-map
            editable
            id="map"
            ref="map"
            :center.sync="map.center"
            :zoom="map.zoom"
            :options="mapOptions"
            style="min-height: 100px"
          >
            <!-- <l-control-polyline-measure :options="{ showUnitControl: false }" position="topleft"/> -->
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />
            <l-polyline
              v-for="item in polylines"
              :key="item.id"
              :color="item.color"
              :fillColor="item.color"
              :lat-lngs="item.latlngs"
              :visible="item.visible"
            ></l-polyline>
            <!-- <editable-polyline editable :lat-lngs="editPolyline"></editable-polyline> -->
          </editable-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LTooltip,
  LControlLayers,
  LPolyline
} from 'vue2-leaflet'
// import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
import { EditableMap } from 'vue2-leaflet-editable'
import vSelect from 'vue-select'
import 'leaflet-draw'

import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  components: {
    vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LPolyline,
    LTooltip,
    LControlLayers,
    EditableMap,
    flatPickr
  },

  data() {
    return {
      color: ['green', 'blue', 'teal', 'orange', 'red', 'purple', 'yellow'],
      data: [],
      actor: {},
      token: '',
      tileProviders: [
        {
          name: 'Google Street',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459),
        zoom: 13
      },

      mapOptions: {
        minZoom: 15,
        zoomSnap: 0.5
      },

      userList: [],

      tempId: '',
      input: {
        user_id: '',
        name: '',
        geom: ''
      },

      deviceList: [],
      track: {
        device: '',
        start: '',
        end: ''
      },

      slider: {
        value: [0, 50],
        max: 50
      },

      action: '',
      fromHistory: false,
      isSearchHistory: false,
      isCropHistory: false,
      defaultHistory: [],

      selected: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',
      timer: null,
      loading: true,

      polylines: [],
      drawPolyline: null,

      notify: 'Server Error'
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    isWider() {
      return this.$store.state.windowWidth >= 1440
    },

    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    sliderValue() {
      return this.slider.value
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    isWider() {
      this.initTable()
    },

    sliderValue(val) {
      const geom = this.defaultHistory.slice(val[0], val[1]).map((item, i) => {
        if (i == 0) {
          this.map.zoom = 16
          this.map.center = L.latLng(item.latitude, item.longitude)
        }
        // return item
        return L.latLng(item.latitude, item.longitude)
      })

      this.input.geom = this.polylineToLinestring(geom)

      const map = this.$refs.map.mapObject
      if (this.drawPolyline) map.removeLayer(this.drawPolyline)
      this.drawPolyline = L.polyline(geom)
      this.drawPolyline.addTo(map) //.enableEdit()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data

        if (this.actor.privilege == 4) {
          this.input.user_id = {
            label: this.actor.username,
            value: this.actor.id
          }
        }
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.initTable()
  },

  mounted() {
    // window.addEventListener('keyup', e => {
    //   if(this.drawPolyline) {
    //     if(e.keyCode == 8) this.drawPolyline.editor.pop()
    //   }
    // })

    this.$nextTick(() => {
      const map = this.$refs.map.mapObject

      map.editTools.on('editable:drawing:commit', (e) => {
        this.input.geom = this.polylineToLinestring(e.vertex.latlngs)
      })

      map.editTools.on('editable:vertex:dragend', (e) => {
        this.input.geom = this.polylineToLinestring(e.vertex.latlngs)
      })

      map.editTools.on('editable:vertex:ctrlclick', (e) => {
        e.vertex.continue()
      })

      map.editTools.on('editable:vertex:click', (e) => {
        if (this.action == 'edit') {
          e.vertex.delete()
          this.input.geom = this.polylineToLinestring(e.vertex.latlngs)
        }
      })

      map.editTools.on('editable:vertex:shiftclick', (e) => {
        if (this.action == 'add') {
          e.vertex.delete()
          this.input.geom = this.polylineToLinestring(e.vertex.latlngs)
        }
      })
    })
  },

  methods: {
    add(history) {
      this.action = 'add'
      const map = this.$refs.map.mapObject
      if (!history) this.drawPolyline = map.editTools.startPolyline()

      this.fromHistory = history
      // L.polyline(this.editPolyline).addTo(map).enableEdit()
    },

    cancel() {
      this.reset()

      this.action = ''

      const map = this.$refs.map.mapObject
      if (!this.fromHistory) {
        map.removeLayer(this.drawPolyline)
        this.drawPolyline.editor.disable()
      }

      this.fromHistory = false
    },

    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    searchGeneral(search) {
      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/general`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              search: search
            }
          })
          .then((res) => {
            this.userList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.userList = []
      }
    },

    searchDevice(keyword) {
      if (keyword.length >= 3) {
        this.$http
          .get(
            `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            this.deviceList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.deviceList = []
      }
    },

    searchTrack() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.endpoint}/job_order/route/track`, {
          params: {
            ...this.track,
            device: this.track.device ? this.track.device.value : ''
          },
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close('#searchBtn > .con-vs-loading')
          const data = res.data.message.data

          this.defaultHistory = data.map((item, i) => {
            return item
          })

          this.slider.max = this.defaultHistory.length - 1
          this.slider.value = [0, this.defaultHistory.length - 1]
          this.isSearchHistory = true
          this.isCropHistory = false
        })
        .catch((error) => {
          this.$vs.loading.close('#searchBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    crop() {
      this.isCropHistory = true
      this.drawPolyline.enableEdit()
    },

    edit(data) {
      this.tempId = data.id
      this.action = 'edit'

      this.userList.push({ value: data.user.id, label: data.user.username })
      this.input.user_id = { value: data.user.id, label: data.user.username }
      this.input.name = data.name
      this.input.geom = data.geom

      const map = this.$refs.map.mapObject
      this.drawPolyline = L.polyline(this.linestringToPolyline(data.geom))
      this.drawPolyline.addTo(map).enableEdit()
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Route`,
        text: 'Are you sure want to Delete this Route ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/job_order/route/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')
          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url =
        this.action === 'add'
          ? `${this.$api.endpoint}/job_order/route/add`
          : `${this.$api.endpoint}/job_order/route/update/${this.tempId}`

      this.$http
        .post(
          url,
          {
            ...this.input,
            user_id: this.input.user_id ? this.input.user_id.value : null
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.cancel()
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          /* Delete drawing layer */
          const map = this.$refs.map.mapObject
          if (this.drawPolyline) map.removeLayer(this.drawPolyline)

          this.initTable()

          this.notify = res.data.message.split('_').join(' ')
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    reset() {
      Object.keys(this.input).map((i) => {
        this.input[i] = ''
      })

      Object.keys(this.track).map((i) => {
        this.track[i] = ''
      })
    },

    check(item, event) {
      let visible = event.target.checked
      let key = -1

      this.polylines.map((data, index) => {
        if (data.id === item.id) key = index
      })

      if (key !== -1) {
        if (visible) {
          this.map.center = this.polylines[key].latlngs[0]
          this.map.zoom = 12
        }
        this.polylines[key].visible = visible
      }
    },

    initTable() {
      this.$http
        .get(
          `${this.$api.endpoint}/job_order/route/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false

          this.polylines = []
          this.data.map((item, i) => {
            let key = -1
            let latlngs = this.linestringToPolyline(item.geom)

            this.polylines.map((i, index) => {
              if (i.id === item.id) key = index
            })

            let visible = false
            if (this.selected.indexOf(item.id) != -1) visible = true

            if (key === -1) {
              this.polylines.push({
                id: item.id,
                name: item.name,
                latlngs: latlngs,
                color: this.color[i % 7],
                visible: visible
              })
            }
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    linestringToPolyline(geom) {
      let start = '('
      let end = ')'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    polylineToLinestring(polygon) {
      let lonlat = ''
      polygon.map((item, index) => {
        // if(index > 0) lonlat += ', '
        if (index === 0) lonlat += `${item.lng} ${item.lat}`
        else lonlat += `, ${item.lng} ${item.lat}`
      })

      return `LINESTRING (${lonlat})`
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/tree.scss';
</style>
